import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex w-full p-4 bg-yellow-50 rounded-md"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-yellow-800" }, [
  /*#__PURE__*/_createTextVNode(" You are about to exceed your Agency daily sending limit of 100. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "underline underline-offset-[3px]"
  }, "Set up a Business Profile to unlock a higher limit.")
], -1)
const _hoisted_3 = { class: "flex flex-row-reverse items-center justify-between w-full" }
const _hoisted_4 = { class: "flex items-center gap-x-4" }
const _hoisted_5 = {
  key: 1,
  class: "flex items-center gap-x-4"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex justify-start items-center" }
const _hoisted_8 = { class: "flex items-center justify-center mr-4 h-12 w-12 rounded-full bg-primary-color-100" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "text-lg leading-6 font-medium text-gray-900" }, "Schedule Text Message", -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex items-center justify-center" }
const _hoisted_12 = { class: "text-base font-medium text-primary-color-600" }
const _hoisted_13 = { class: "text-sm text-gray-500" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-medium text-primary-color-600" }, "Pick Date & Time", -1)
const _hoisted_15 = {
  key: 0,
  class: "flex gap-x-4 mt-2"
}
const _hoisted_16 = { class: "flex justify-end" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_18 = { class: "flex flex-col justify-center items-center" }
const _hoisted_19 = { class: "flex items-center justify-center mr-4 h-12 w-12 rounded-full bg-yellow-100 mb-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h1", { class: "text-lg leading-6 font-medium text-gray-900 mb-2" }, "Failed To Send Text Message", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-sm font-normal text-gray-500 mb-6" }, " You have exceeded your Agency daily message sending limit of 100. Set up a Business Profile to unlock a higher limit ", -1)

import { computed, onMounted, ref, provide, watch } from "vue"
import { useRoute, useRouter } from "vue-router"

import { CalendarIcon, DocumentTextIcon, ClockIcon, ExclamationCircleIcon } from "@heroicons/vue/outline"
import { ExclamationIcon } from "@heroicons/vue/solid"
import GgmsTextarea from "@/components/GgmsTextarea.vue"
import GgmsButton from "@/components/GgmsButton.vue"
import GgmsModal from "@/components/GgmsModal.vue"
import GgmsSeparator from "@/components/GgmsSeparator.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsEmojiPicker from "@/components/GgmsEmojiPicker.vue"
import MessageTemplatesModal from "./message/MessageTemplatesModal.vue"
import GgmsBasicEmailParts from "@/components/GgmsBasicEmailParts.vue"
import { useAgencyStore } from "@/stores/agency"
import { useMessageStore } from "@/stores/message"
import { useConfigStore } from "@/stores/config"
import { useLeadsStore } from "@/stores/leads"
import { ToastService } from "@/shared/services/toast"
import { Message } from "@/shared/models/message"
import { Error } from "@/shared/models/error"
import { IntegrationName } from "@/shared/models/integration"
import { Phone } from "@/shared/models/phone"
import { Sender } from "@/shared/models/sender"
import { InboxContact } from "@/shared/models/inbox"
import { Lead } from "@/shared/models/lead"
import {
    getDateInputFormat,
    getTimeInputFormat,
    setTomoroowMorning,
    setThisAfternoon,
    formatHumanReadableDate,
    getUser,
    getDisplayName,
} from "@/shared/utils/helpers"
import { useWorkflowStore } from "@/stores/workflow"
import { CountryCode } from "libphonenumber-js"
import GgmsWarningBanner from "@/components/GgmsWarningBanner.vue"
import DNDWarningComponent from "@/components/profile-details/do-not-disturb/DNDWarningComponent.vue"

interface Props {
    isWorkflow?: boolean
    hasEmails?: boolean
    hasTwilio?: boolean
    textMessage?: Message
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatingMessage',
  props: {
    isWorkflow: { type: Boolean, default: false },
    hasEmails: { type: Boolean, default: false },
    hasTwilio: { type: Boolean, default: false },
    textMessage: {}
  },
  emits: ["sendFromInbox", "saveTextMessage"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter()

const emit = __emit

const props = __props

const agencyStore = useAgencyStore()
const leadStore = useLeadsStore()
const messageStore = useMessageStore()
const toastService = new ToastService()
const configStore = useConfigStore()
const workflowStore = useWorkflowStore()
const route = useRoute()

provide("contactOverlayTarget-to", "creatingMessage")
provide("contactOverlayTarget-cc", "creatingMsgCcField")
provide("contactOverlayTarget-bcc", "creatingMsgCcField")

const messageTextArea = ref()
const message = ref("")
const recipients = ref<InboxContact[]>([])

const agency = ref(agencyStore.agency)
const agencyPhoneNumber = ref((getUser().outboundPhoneNumber || agency.value?.agencyOutboundPhoneNumber) as Phone)
const selectedSender = ref({ name: agency.value.agencyName || "", phone: agencyPhoneNumber.value } as Sender)
const isTemplatesModalOpen = ref(false)
const isOpenScheduleMessageModal = ref(false)
const isOpenCustomSchedule = ref(false)

const customScheduleDate = ref(getDateInputFormat(new Date()))
const customScheduleTime = ref(getTimeInputFormat(new Date()))

const scheduleDate = ref<Date>()
const scheduleOptions = ref([
    {
        text: "Tomorrow morning",
        date: setTomoroowMorning(),
    },
])
const validationErrorMessage = computed(
    () => messageStore.validationError.fullMessage || messageStore.validationError.message
)
const twilioIntegration = computed(() =>
    configStore.integrations.find((i) => i.integrationName === IntegrationName.twilio)
)
const remainingDailySentMessagesLimit = computed(() => twilioIntegration.value?.remainingDailySentMessagesLimit || 500)
const remainingDailySentMessagesThreshold = computed(
    () => twilioIntegration.value?.remainingDailySentMessagesThreshold || 250
)
const isMessageLimitModalOpen = ref(false)
const emojis = ref("")
const isCreatingMessage = ref(false)

const disabledClass = computed(() =>
    isCreatingMessage.value ? "opacity-50 pointer-events-none cursor-not-allowed" : ""
)

function getStyleType() {
    if (props.hasEmails && props.hasTwilio) return "emailAndPhone"
    if (props.hasEmails) return "onlyEmail"
    if (props.hasTwilio) return "onlyPhone"
    return "primary"
}

async function createMessage() {
    try {
        isCreatingMessage.value = true
        if (props.isWorkflow) {
            emit("saveTextMessage")
        }
        const to = recipients.value.map((contact) => {
            const fullNameParts = contact.fullName?.split(" ")
            const reversedParts = fullNameParts?.reverse() || []

            const lastName = reversedParts.shift()
            const firstName = reversedParts.reverse().join(" ") || ""

            return {
                firstName,
                lastName,
                phone: {
                    number: contact.phone?.number || "",
                    country: contact.phone?.country || "RO",
                },
                _id: contact._id,
            }
        })
        const messagePayload: Message = {
            body: message.value,
            plain: message.value,
            from: {
                name: selectedSender.value?.name || "",
                number: selectedSender.value.phone?.number || "",
                country: selectedSender.value.phone?.country || "",
            },
            to,
        }
        if (!messagePayload?.to?.length && !props.isWorkflow) {
            toastService.addToast({
                message: "Unable to send message. There are no contacts to send the message to.",
                type: "error",
            })
            return
        }
        if (twilioIntegration.value) {
            messagePayload.integration = {
                _id: twilioIntegration.value._id,
                integrationName: twilioIntegration.value.integrationName,
                integrationType: twilioIntegration.value.integrationType,
            }
        }

        if (scheduleDate.value) {
            messagePayload.scheduledAt = scheduleDate.value
        }
        if (!scheduleDate.value && remainingDailySentMessagesLimit.value <= 0) {
            isMessageLimitModalOpen.value = true
            return
        }

        const leadId = leadStore.lead._id
        if (leadId) {
            if (props.isWorkflow) {
                workflowStore.messagePayload = messagePayload
            } else {
                await messageStore.createMessage(messagePayload, leadStore.lead._id)
                emit("sendFromInbox")
            }
        } else {
            if (props.isWorkflow) {
                workflowStore.messagePayload = messagePayload
            } else {
                await messageStore.createMessage(messagePayload)
                emit("sendFromInbox")
            }
        }

        message.value = ""
        scheduleDate.value = undefined
        if (leadStore.lead?.phones) {
            addRecipient(leadStore.lead)
            return
        }
        recipients.value = []
    } finally {
        isCreatingMessage.value = false
    }
}

function openScheduleMessageModal() {
    isOpenScheduleMessageModal.value = true
    const afternoonSchedule = setThisAfternoon(scheduleOptions.value)
    if (afternoonSchedule) {
        scheduleOptions.value.push(afternoonSchedule)
    }
}

function closeScheduleMessageModal() {
    isOpenScheduleMessageModal.value = false
    isOpenCustomSchedule.value = false
    customScheduleDate.value = getDateInputFormat(new Date())
    customScheduleTime.value = getTimeInputFormat(new Date())
}

function toggleCustomSchedule() {
    isOpenCustomSchedule.value = !isOpenCustomSchedule.value
}

function getCustomScheduledTime() {
    const date = new Date(customScheduleDate.value)
    const hours = Number(customScheduleTime.value.split(":")[0])
    const minutes = Number(customScheduleTime.value.split(":")[1])
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes)
}

function saveScheduleMessage(date?: Date) {
    scheduleDate.value = date || getCustomScheduledTime()

    createMessage()
    closeScheduleMessageModal()
}

function disableValidationError() {
    messageStore.validationError = {} as Error
}

function closeMessageLimitModal() {
    isMessageLimitModalOpen.value = false
}

function setEmojiInTextarea(emoji: string) {
    emojis.value = emoji
}

function updateTemplate(template: { subject: string; body: string }) {
    message.value = template.body
}

function addRecipient(lead: Lead, index?: number) {
    const recipient = {
        _id: lead._id,
        fullName: getDisplayName({
            firstName: lead.firstName,
            lastName: lead.lastName,
        }),
        doNotDisturb: lead?.doNotDisturb,
        phone: lead.phones?.[0],
    } as InboxContact

    if (!recipients.value.map((recipient) => recipient._id).includes(recipient._id) && recipient?.phone?.number) {
        index ? recipients.value.splice(index, 0, recipient) : recipients.value.push(recipient)
    }
}

//--------------------------------------------COST VALIDATION--------------------------------------------//

const costExceeded = ref(false)

function setCostExceeded(isExceeded: boolean) {
    costExceeded.value = isExceeded
}

//--------------------------------------------COST VALIDATION END----------------------------------------//

onMounted(() => {
    messageStore.timelineMessageTextAreaRef = messageTextArea?.value?.textarea
    if (leadStore.lead.phones?.length && !props.isWorkflow && route.name !== "inbox") {
        addRecipient(leadStore.lead)
    }
    if (props.isWorkflow && props.textMessage) {
        message.value = props.textMessage.body
        selectedSender.value = {
            name: props.textMessage.from.name || "",
            phone: {
                number: props.textMessage.from.number,
                country: props.textMessage.from.country as CountryCode,
            },
        }
    }
})

watch(
    () => leadStore.lead.phones,
    () => {
        const leadRecipientIndex = recipients.value.findIndex((recipient) => recipient._id === leadStore.lead._id)
        if (leadRecipientIndex < 0) {
            return
        }
        addRecipient(leadStore.lead, leadRecipientIndex)
    },
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['flex flex-col justify-center items-center px-4 py-6 gap-y-3 relative', disabledClass.value])
    }, [
      _createVNode(GgmsBasicEmailParts, {
        recipients: recipients.value,
        "onUpdate:recipients": _cache[0] || (_cache[0] = ($event: any) => ((recipients).value = $event)),
        selectedSender: selectedSender.value,
        "onUpdate:selectedSender": _cache[1] || (_cache[1] = ($event: any) => ((selectedSender).value = $event)),
        isWorkflow: _ctx.isWorkflow,
        type: "sms"
      }, null, 8, ["recipients", "selectedSender", "isWorkflow"]),
      _createVNode(DNDWarningComponent, {
        recipients: recipients.value,
        showLeadName: true
      }, null, 8, ["recipients"]),
      _createVNode(GgmsTextarea, {
        ref_key: "messageTextArea",
        ref: messageTextArea,
        modelValue: message.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event)),
        "template-string": emojis.value,
        placeholder: "Write your text",
        styleType: getStyleType(),
        rows: 11,
        "error-message": validationErrorMessage.value,
        invalid: !!validationErrorMessage.value,
        "is-count-available": true,
        "number-of-recipients": recipients.value.length,
        class: "w-full pb-0.5",
        onDisableValidationError: disableValidationError,
        onCostExceeded: setCostExceeded
      }, null, 8, ["modelValue", "template-string", "styleType", "error-message", "invalid", "number-of-recipients"]),
      (remainingDailySentMessagesThreshold.value <= 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(ExclamationIcon), { class: "h-6 w-6 text-yellow-400 mr-3" }),
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(DocumentTextIcon), {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (isTemplatesModalOpen.value = true)),
            class: "w-6 h-6 cursor-pointer text-gray-400 hover:text-gray-600"
          }),
          (_ctx.isWorkflow)
            ? (_openBlock(), _createBlock(GgmsButton, {
                key: 0,
                classes: ['rounded-md'],
                disabled: isCreatingMessage.value,
                onClick: createMessage
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save")
                ]),
                _: 1
              }, 8, ["disabled"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(GgmsEmojiPicker, { onSendEmoji: setEmojiInTextarea }),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(GgmsButton, {
                    classes: ['rounded-md rounded-r-none'],
                    disabled: isCreatingMessage.value || costExceeded.value,
                    onClick: createMessage
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Send Text Message")
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(GgmsButton, {
                    classes: ['px-2 rounded-md rounded-l-none'],
                    onClick: openScheduleMessageModal
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CalendarIcon), { class: "w-6 h-6 text-white" })
                    ]),
                    _: 1
                  })
                ])
              ]))
        ])
      ]),
      (costExceeded.value)
        ? (_openBlock(), _createBlock(GgmsWarningBanner, {
            key: 1,
            "class-name": "w-full"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" You don’t have enough points to send this message. Please top up first from the "),
              _createElementVNode("span", {
                class: "font-medium text-primary-color-500 cursor-pointer",
                onClick: _cache[4] || (_cache[4] = () => _unref(router).push(`/billing`))
              }, " Plans & Billing "),
              _createTextVNode(" section ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(MessageTemplatesModal, {
        open: isTemplatesModalOpen.value,
        "template-title": "Text Message",
        onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (isTemplatesModalOpen.value = false)),
        "onUpdate:modelValue": updateTemplate,
        size: "3xl"
      }, null, 8, ["open"])
    ], 2),
    _createVNode(GgmsModal, {
      open: isOpenScheduleMessageModal.value,
      onCloseModal: closeScheduleMessageModal
    }, _createSlots({
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(CalendarIcon), { class: "h-6 w-6 text-primary-color-600" })
          ]),
          _hoisted_9
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scheduleOptions.value, (schedule) => {
          return (_openBlock(), _createElementBlock("div", {
            key: schedule.text
          }, [
            _createElementVNode("div", {
              class: "flex justify-between items-center cursor-pointer",
              onClick: ($event: any) => (saveScheduleMessage(schedule.date))
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(ClockIcon), { class: "h-5 w-5 text-primary-color-600 mr-3" }),
                _createElementVNode("p", _hoisted_12, _toDisplayString(schedule.text), 1)
              ]),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(formatHumanReadableDate)(schedule.date, true)), 1)
            ], 8, _hoisted_10),
            _createVNode(GgmsSeparator, { class: "my-4" })
          ]))
        }), 128)),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "flex items-center w-fit border-none bg-transparent",
            onClick: toggleCustomSchedule
          }, [
            _createVNode(_unref(CalendarIcon), { class: "h-5 w-5 text-primary-color-600 mr-3" }),
            _hoisted_14
          ]),
          (isOpenCustomSchedule.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(GgmsInput, {
                  modelValue: customScheduleDate.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((customScheduleDate).value = $event)),
                  class: "w-full",
                  type: "date",
                  iconStart: _unref(CalendarIcon)
                }, null, 8, ["modelValue", "iconStart"]),
                _createVNode(GgmsInput, {
                  modelValue: customScheduleTime.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((customScheduleTime).value = $event)),
                  class: "w-full",
                  type: "time",
                  iconStart: _unref(ClockIcon)
                }, null, 8, ["modelValue", "iconStart"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (isOpenCustomSchedule.value)
        ? {
            name: "under",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(GgmsButton, {
                  styleType: "secondary",
                  class: "mr-3",
                  onClick: closeScheduleMessageModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                }),
                _createVNode(GgmsButton, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (saveScheduleMessage()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Done")
                  ]),
                  _: 1
                })
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["open"]),
    _createVNode(GgmsModal, {
      open: isMessageLimitModalOpen.value,
      size: "sm",
      onCloseModal: closeMessageLimitModal
    }, {
      header: _withCtx(() => [
        _hoisted_17
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_unref(ExclamationCircleIcon), { class: "h-6 w-6 text-yellow-600" })
          ]),
          _hoisted_20,
          _hoisted_21,
          _createVNode(GgmsButton, {
            styleType: "primary",
            onClick: closeMessageLimitModal,
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Set Up Business Profile")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})